import { MutationTree } from 'vuex';

import { UserI } from '@/store/auth/state';
import {
  ServicesStateI,
  ServiceI,
} from './state';

export const mutations: MutationTree<ServicesStateI> = {
  setServices(state: ServicesStateI, payload: ServiceI[]) {
    state.services = payload;
  },
  setService(state: ServicesStateI, payload: ServiceI) {
    state.service = payload;
  },
};
